import { useCallback, useState } from "react";
import { Card } from "../../components/Card";
import { UserTable } from "./components/UserTable";
import { Button } from "../../components/Button";
import { useQuery } from "@tanstack/react-query";
import { UserFormModal } from "./components/UserFormModal";
import { api } from "../../services/api";

export function UsersList() {
  const [editUser, setEditUser] = useState<any>(null);

  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const handleAddUser = useCallback(() => {
    setEditUser(null);
    setIsAddUserModalOpen(true);
  }, []);

  const {
    data: usersData,
    isLoading: isLoadingUsers,
    refetch,
  } = useQuery({
    queryKey: [`search-users`],
    queryFn: () => api.searchUsers(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleEditUser = useCallback((user: any) => {
    setEditUser(user);
    setIsAddUserModalOpen(true);
  }, []);

  const users = usersData?.users || [];
  return (
    <>
      <Card>
        <div className="md:mb-6 flex items-center justify-between">
          <div>
            <div className="text-text-primary text-2xl font-bold">Manage Members</div>
          </div>
          <Button
            variant="primary"
            className="!py-3 !rounded-full"
            onClick={handleAddUser}
          >
            Add users
          </Button>
        </div>
        <UserTable
          users={users || []}
          isLoading={isLoadingUsers}
          refetch={refetch}
          onEditUser={handleEditUser}
        />
      </Card>
      <UserFormModal
        isOpen={isAddUserModalOpen}
        onClose={() => {
          setEditUser(null);
          setIsAddUserModalOpen(false);
        }}
        user={editUser}
        onSuccess={() => {
          setIsAddUserModalOpen(false);
          refetch();
        }}
      />
    </>
  );
}
